module.exports = __webpack_public_path__ + "static/media/calendar_31_days.7c41de89.svg";